"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportCustomerExcel = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment"));
var exportCustomerExcel = exports.exportCustomerExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var customer, fileName, workbook, worksheet, fontRedBold, cellStyle, styleCell, columnTable, headerRow, columns, data, startRow, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          customer = _ref.customer;
          fileName = "CUSTOMER FILE";
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Customer", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            }
          });
          fontRedBold = {
            bold: true,
            size: 11,
            color: {
              argb: "ffff0202"
            }
          }; // style cell
          cellStyle = {
            border: {
              top: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              left: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              bottom: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              right: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              }
            }
          };
          styleCell = {
            primaryCell: {
              font: {
                bold: true,
                color: {
                  argb: "ffff181a"
                },
                size: 10
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle"
              }
            },
            subCell: {
              font: {
                bold: true,
                color: {
                  argb: "ff427c27"
                },
                size: 10
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle"
              }
            },
            boldCell: {
              font: {
                bold: true,
                size: 10
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle"
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {
                  argb: 'ffff01'
                },
                bgColor: {
                  argb: 'ffff01'
                }
              }
            }
          }; //add table
          columnTable = [{
            label: "No.",
            style: styleCell.boldCell,
            width: 20,
            prop: "customerIndex"
          }, {
            label: "Customer's code",
            style: styleCell.boldCell,
            width: 20,
            prop: "code"
          }, {
            label: "Name",
            style: styleCell.boldCell,
            width: 20,
            prop: "name"
          }, {
            label: "Phone",
            style: styleCell.boldCell,
            width: 20,
            prop: "phone"
          }, {
            label: "Email",
            style: styleCell.boldCell,
            width: 20,
            prop: "email"
          }, {
            label: "Birthday",
            style: styleCell.boldCell,
            width: 20,
            prop: "birthday"
          }, {
            label: "Age",
            style: styleCell.boldCell,
            width: 20,
            prop: "age"
          }, {
            label: "Gender",
            style: styleCell.boldCell,
            width: 20,
            prop: "gender"
          }, {
            label: "Skin status",
            style: styleCell.boldCell,
            width: 20,
            prop: "skinStatusName"
          }, {
            label: "Rank",
            style: styleCell.boldCell,
            width: 20,
            prop: "customerRank.name"
          }, {
            label: "Staff",
            style: styleCell.boldCell,
            width: 20,
            prop: "staff.name"
          }, {
            label: "Group",
            style: styleCell.boldCell,
            width: 20,
            prop: "customerGroup.name"
          }, {
            label: "Source",
            style: styleCell.boldCell,
            width: 20,
            prop: "customerSource.name"
          }, {
            label: "City",
            style: styleCell.boldCell,
            width: 20,
            prop: "receiverCityName"
          }, {
            label: "District",
            style: styleCell.boldCell,
            width: 20,
            prop: "receiverDistrictName"
          }, {
            label: "Ward",
            style: styleCell.boldCell,
            width: 20,
            prop: "receiverWardName"
          }, {
            label: "Address",
            style: styleCell.boldCell,
            width: 20,
            prop: "receiverAddress"
          }, {
            label: "Note",
            style: styleCell.boldCell,
            width: 20,
            prop: "note"
          }, {
            label: "Company name",
            style: styleCell.boldCell,
            width: 20,
            prop: "companyName"
          }, {
            label: "Tax code",
            style: styleCell.boldCell,
            width: 20,
            prop: "taxCode"
          }, {
            label: "Website",
            style: styleCell.boldCell,
            width: 20,
            prop: "website"
          }, {
            label: "Facebook",
            style: styleCell.boldCell,
            width: 20,
            prop: "facebook"
          }, {
            label: "Register member Date",
            style: styleCell.boldCell,
            width: 20,
            prop: "registerAt",
            numFmt: "d/m/yyyy"
          }, {
            label: "Created customer date",
            style: styleCell.boldCell,
            width: 20,
            prop: "createdAt",
            numFmt: "d/m/yyyy"
          }];
          headerRow = worksheet.getRow(2);
          headerRow.values = columnTable.map(function (e) {
            return e.label;
          });
          headerRow.height = 50;
          headerRow.eachCell(function (cell, colNum) {
            // cell.value = columnTable[colNum - 1].label;
            cell.style = columnTable[colNum - 1].style;
          });
          columns = worksheet.columns;
          columns.forEach(function (col, i) {
            col.width = columnTable[i].width;
          });
          //generate data
          data = customer.map(function (e, index) {
            e.skinStatusName = e.skinStatuses.map(function (skin) {
              return skin.name;
            }).join(', ');
            e.age = (0, _moment.default)().diff((0, _moment.default)(e.birthday, "DD/MM/YYYY").valueOf(), "years", false) || "--";
            e.customerIndex = index + 1;
            e.registerAt = e.registerAt ? _moment.default.unix(e.registerAt).toDate() : '--';
            e.createdAt = e.createdAt ? _moment.default.unix(e.createdAt).toDate() : '--';
            var tmp = [];
            columnTable.forEach(function (col) {
              var value = (0, _utils.generateProp)(e, col.prop);
              tmp.push({
                value: value,
                numFmt: col.numFmt
              });
            });
            return tmp;
          });
          startRow = 3;
          data.forEach(function (element) {
            var row = worksheet.getRow(startRow++);
            row.values = element.map(function (e) {
              return e.value;
            });
            row.eachCell(function (cell, index) {
              var col = element[index - 1];
              // @ts-ignore
              cell.style = cellStyle;
              col.numFmt && (cell.numFmt = col.numFmt);
              // element.numFmt && (worksheet.getCell(`${tmpChar}${rowIndex}`).numFmt = element.numFmt)
            });
          });
          _context.next = 19;
          return workbook.xlsx.writeBuffer();
        case 19:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportCustomerExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();